import { Link } from "react-router-dom";
import { Home } from "lucide-react";
import { Seo } from "@/components/common/Seo";

export default function NotFound() {
  return (
    <div
      data-testid="not-found-page"
      className="flex min-h-screen flex-col items-center justify-center bg-brand-soft px-6 text-center"
    >
      <Seo title="Page Not Found | Dr. Ankesh Seth" description="The page you're looking for doesn't exist." path="/404" noindex />
      <span className="font-display text-8xl font-bold text-brand-blue md:text-9xl">404</span>
      <h1 className="mt-4 font-display text-3xl font-semibold text-brand-dark md:text-4xl">
        Page not found
      </h1>
      <p className="mt-3 max-w-md text-brand-muted">
        The page you&apos;re looking for doesn&apos;t exist. Let&apos;s get you back to a healthy smile.
      </p>
      <Link
        to="/"
        className="mt-8 inline-flex items-center gap-2 rounded-full bg-brand-blue px-6 py-3 text-sm font-semibold text-white transition-all hover:bg-brand-bluehover active:scale-95"
      >
        <Home className="h-4 w-4" /> Back to Home
      </Link>
    </div>
  );
}
